// Denúncia do nome de uma sala pública: uma por conta Google. O aparelho lembra as salas já denunciadas.
import type { Sessao } from './conta.ts';
import { mesaHttp } from './config.ts';

const CHAVE = 'truco6:salas-denunciadas';

function lidas(): string[] {
  try { const x = JSON.parse(localStorage.getItem(CHAVE) ?? '[]') as unknown; return Array.isArray(x) ? x.filter((s) => typeof s === 'string') : []; } catch { return []; }
}

export function jaDenunciou(sala: string): boolean {
  return lidas().includes(sala);
}

function lembrar(sala: string): void {
  try { localStorage.setItem(CHAVE, JSON.stringify([...lidas().filter((s) => s !== sala), sala].slice(-200))); } catch { /* sem armazenamento: só não lembra */ }
}

// 'ok': enviada agora; 'ja': a conta já tinha denunciado; senão, a mensagem do erro.
export async function denunciarSala(sessao: Sessao, sala: { id: string; codigo: string }): Promise<'ok' | 'ja' | string> {
  try {
    const r = await fetch(`${mesaHttp}/salas/${sala.codigo}/denunciar`, { method: 'POST', headers: { authorization: 'Bearer ' + (await sessao.token()) } });
    if (r.ok || r.status === 409) { lembrar(sala.id); return r.ok ? 'ok' : 'ja'; }
    const corpo = (await r.json().catch(() => ({}))) as { mensagem?: string };
    return corpo.mensagem ?? 'A denúncia não foi. Tente de novo.';
  } catch {
    return 'A denúncia não foi. Tente de novo.';
  }
}
